import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ArrowUpRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const params = category ? `?category=${category}` : '';
        const response = await axios.get(`${API}/articles${params}`);
        setArticles(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, [category]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory" data-testid="articles-loading">
        <p className="label-editorial">Loading</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ivory" data-testid="articles-page">
      <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-16 text-center">
            <p className="label-editorial mb-4">The Behenchara Magazine</p>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-tight text-charcoal" data-testid="articles-title">
              {category ? category : 'Stories, ideas, ambition.'}
            </h1>
            <p className="text-lg text-charcoal-muted max-w-2xl mx-auto mt-6">
              Essays, interviews, personal stories and research from women around the world.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {articles.map((article) => (
              <Link
                key={article.article_id}
                to={`/articles/${article.slug}`}
                className="editorial-card group"
                data-testid={`article-${article.article_id}`}
              >
                {article.cover_image && (
                  <div className="aspect-[4/3] overflow-hidden mb-6">
                    <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" />
                  </div>
                )}
                <p className="label-editorial mb-3">{article.category} · {article.reading_time} min</p>
                <h3 className="font-serif text-2xl text-charcoal mb-3 leading-snug group-hover:text-burgundy transition-colors">
                  {article.title}
                </h3>
                <p className="text-charcoal-muted line-clamp-2 mb-4 text-sm">{article.excerpt}</p>
                <div className="flex items-center justify-between border-t border-subtle pt-4">
                  <p className="text-xs text-muted-warm font-mono uppercase tracking-widest">By {article.author_name}</p>
                  <ArrowUpRight className="h-4 w-4 text-burgundy group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>

          {articles.length === 0 && (
            <div className="text-center py-16">
              <p className="text-charcoal-muted text-lg">No articles yet in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Articles;
